import React, { Fragment, useEffect, useState } from "react";
import styles from "./layout.module.css";
import { IoMdHome } from "react-icons/io";
import { FaCarSide } from "react-icons/fa6";
import { FaCalendarAlt, FaCar, FaClipboardList } from "react-icons/fa";
import { GiAutoRepair } from "react-icons/gi";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { GrHostMaintenance } from "react-icons/gr";
import TopNav from "./top-nav/top-nav";
import { useSelector } from "react-redux";

const Layout = () => {
  const [isActive, setIsActive] = useState("/");
  const [fullName, setFullName] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  // const user = useSelector((state) => state.user.userId);
  const user = useSelector((state) => state.user.user);

  useEffect(() => {
    switch (location.pathname) {
      case "/":
        setIsActive("/");
        break;
      case "/add-car":
        setIsActive("/add-car");
        break;
      case "/add-service":
        setIsActive("/add-service");
        break;
      case "/all-services":
        setIsActive("/all-services");
        break;

      default:
        setIsActive("");
        break;
    }
  }, [location.pathname]);
  const style = { margin: "auto"}

  useEffect(() => {
    setFullName(user.fullName)
    setImageUrl(user.imageUrl)
  }, [user])


  return (
    <Fragment>
      
      <div className="mb-3">
        <TopNav user={{
        fullName: user.fullName,
        avatarUrl: user.imageUrl
        // avatarUrl: "https://i.pravatar.cc/150?img=5"
      }}/>
      </div>

      <main>
        <Outlet />
      </main>

      <nav className={styles["mobile-bottom-nav"]}>
        {[
          { path: "/", icon: <IoMdHome />, label: "خانه" },
          { path: "/add-car", icon: <FaCarSide />, label: "خودروی جدید" },
          { path: "/add-service", icon: <GiAutoRepair />, label: "سرویس جدید" },
          { path: "/all-services", icon: <FaClipboardList />, label: "همه سرویس‌ها" },
        ].map((item) => (
          <div
            key={item.path}
            className={`${styles["mobile-bottom-nav__item"]} ${
              isActive === item.path ? styles.color : ""
            }`}
            onClick={() => navigate(item.path)}
          >
            <div className={styles["mobile-bottom-nav__item-content"]}>
              {React.cloneElement(item.icon, { className: styles["material-icons"] })}
              <span>{item.label}</span>
            </div>
          </div>
        ))}
      </nav>
    </Fragment>
  );
};

export default Layout;
